export const APP_CONSTANTS = {
  DEFAULT_ROUTE: "/asset-management",
  UNAUTHORISED_ROUTE: "/unauthorised",
  MTC_TITLE: "MyTRUMPF Cockpit",
  MTC_AM_TITLE: "Asset Management",
  MTC_SETTINGS_TITLE: "Settings",
  MTC_AM_TAB_ASSET_TYPE_LIST: "asset-type-list",
  MTC_AM_TAB_ASSET_LIST: "asset-list",
  MTC_AM_TAB_TECHNOLOGY_LIST: "technology-list",
  PAGINATION_PAGE_SIZE: 10,
  QUERY_PAGE_SIZE: 10,
  DEBOUNCE_TIME: 200,
  MAX_API_RESULTS_LIMIT: 100
};

export const API_ENDPOINTS = {
  INTROSPECTION: "/groups/1.0/groups/me",
  ASSET_MANAGEMENT: "/asset-management",
  ASSET_TYPES: "/management/assetTypes",
  ASSETS: "/core/assets",
  CUSTOMERS: "/management/customers",
  TECHNOLOGIES: "/management/technologies",
  TRUMPF_COMPANIES: "/management/trumpfCompanies",
  USERS: "/management/users",
  COUNTRIES: "/core/countries"
};

const assetManagementPrefix = "/asset-management";
const settingsPrefix = "/settings";
const featureTogglesPrefix = "/feature-toggles";

export const ROUTES = {
  UNAUTHORISED: "/",
  ASSET_TYPE_ASSETS: assetManagementPrefix + "/asset-type/assets",
  ASSET_TYPE_DETAIL: assetManagementPrefix + "/asset-type",
  ASSET_MANAGEMENT: assetManagementPrefix,
  ASSET_TYPES: assetManagementPrefix + "/asset-type",
  ASSETS: assetManagementPrefix + "/asset",
  TECHNOLOGIES: assetManagementPrefix + "/technology",
  SETTINGS: settingsPrefix,
  TRUMPF_ORGANISATIONS: settingsPrefix + "/trumpf-organisation",
  CUSTOMER_MAPPING: settingsPrefix + "/customer-mapping",
  ACCESS_CONTROL: settingsPrefix + "/access-control",
  FEATURE_TOGGLES: featureTogglesPrefix,
  FEATURE_TOGGLES_DETAILS: featureTogglesPrefix + "/details",
  FEATURE_TOGGLES_CHANGELOG: featureTogglesPrefix + "/changelog",
  LOGOUT: "logout"
};
